import { SxProps, Theme } from '@mui/system';

const classes = {
  mainContainer: {
    display: 'flex',
    backgroundColor: 'common.lightBackgroundColor',
    width: '100%',
    height: '100%',
    minHeight: '100vh',
  },

  contentContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },

  content: {
    display: 'flex',
    padding: '10px',
    flexDirection: 'column',
    flex: 1,
  },
} satisfies Record<string, SxProps<Theme>>;

export default classes;
